export default __webpack_public_path__ + "static/images/lisa_06.png";